/**
 * Copyright 2022 Loop Technology, Inc.
 */

//UI Action Types
export const SET_UI_ERRORS = "SET_UI_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_UI_ERRORS = "CLEAR_UI_ERRORS";
export const SET_UI = "SET_UI";
